import { useTranslation } from "react-i18next";
import { ConfirmModal } from "./ConfirmModal";

export function Reset() {
    const { t } = useTranslation();

    const contentProps = {
        title: t("reset"),
        description: t("administrateCard.confirmReset")
    }

    return <ConfirmModal {...contentProps} />


}
